import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/Users/authSlice';
import dogReducer from '../slices/Dogs/dogsSlice';
import roomReducer from '../slices/Rooms/roomsSlice';
import bookingReducer from '../slices/Bookings/bookingsSlice';
import zipcodeReducer from '../slices/ZipCode/zipCodeSlice';
import userProfileReducer from '../slices/Users/userProfileSlice'
import adminReducer from '../slices/Admin/adminSlice'; // adjust path
import blogReducer from '../slices/Blog/blogSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dogs: dogReducer,
    rooms: roomReducer,
    bookings: bookingReducer,
    zipcode: zipcodeReducer,
    userProfile: userProfileReducer,
    admin: adminReducer,
    blog: blogReducer, // <-- Add this line
  },
});